<template>
  <div class="container">
    <v-dialog v-model="mostrar" persistent>
        <v-col cols="12">
            <v-card>
                <v-row>
                    <v-col cols="1"></v-col>
                    <v-col cols="6">
                        <v-card-title class="titulopagina"> Producción Planta Harina - Recepciones</v-card-title>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                        <v-btn dark color="orange darken-1"  @click="mostrar=false">Cerrar</v-btn>
                    </v-col>
                </v-row>
                <v-card-text>
                    <v-row>
                        <v-col cols="2" sm="3">
                            <date-picker class="dtpicker" v-model="fecha" @change="cargarDatos" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                        </v-col>
                        <v-col cols="2" sm="3">
                            <v-btn color="success" @click="guardarProduccion">Grabar producción</v-btn>
                        </v-col>
                        <v-col cols="8" sm="6" v-if="alert">
                            <v-alert dense text type="success">
                            Producción día Guardada Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

        <!-- detalle jumbos -->
        <v-col cols="12">
            <v-card>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th class="text-center blue darken-4">Linea</th>
                            <th class="text-center blue darken-4">Materia Prima</th>
                            <th class="text-center blue darken-4">Maxisacos (PA'S)</th>
                            <th class="text-center blue darken-4">Kilos Harina Sistema</th>
                            <th class="text-center blue darken-4">Total Consolidado</th>
                            <!-- <th class="text-center">Cantidad Maxisacos</th> -->
                            <th class="text-center blue darken-4">Peso Por Maxisaco (Kg Aprox.)</th>
                            <th class="text-center blue darken-4">Materia Prima Producción</th>
                            <th class="text-center blue darken-4">Produccion Harina (Kg)</th>
                            <th class="text-center blue darken-4">Estanque(s) Aceite</th>
                            <th class="text-center blue darken-4">Produccion Aceite</th>
                            <th class="text-center blue darken-4">Folio de Producción</th>
                            <th class="text-center blue darken-4">Agregar Prod. Aceite</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,idx) in lista" :key="item.id">
                            <td class="text-center">{{item.id?item.linea.nombre_linea:item.linea}}</td>
                            <td class="text-center">{{item.id?item.tipo_mp.tipo_materia_prima:item.materia_prima}}</td>
                            <td class="text-center"><v-btn @click="verJumbos(item)" icon><v-icon>visibility</v-icon></v-btn>({{item.cantidad_jumbos_sistema}})</td>
                            <td class="text-center">{{item.total_kilos_sistema}}</td>
                            <td class="text-center">{{item.produccion}} / <v-badge color="green" :content="item.rendimiento" >  </v-badge></td>
                            <!-- <td class="text-center"><v-text-field v-model="item.cantidad_jumbos" type="number" outlined dense></v-text-field></td> -->
                            <td class="text-center">{{item.peso_aproximado_jumbo}}</td>
                            <td class="text-center">
                                <v-text-field v-model="item.mp_procesada" type="number" outlined dense @input="calcularRendimiento(idx,item)" hide-details="auto">
                                </v-text-field>
                                <span>{{ item.mp_procesada_label }}</span>
                            </td>
                            <td class="text-center"><v-text-field class="mt-1" v-model="item.produccion" type="number" outlined dense @input="calcularPesoJumbo(idx,item)" hide-details="auto"></v-text-field></td>
                            <td class="text-center">
                                <v-select
                                    v-for="(estanque, index) in item.estanques"
                                    :key="index"
                                    v-model="item.estanques[index]"
                                    :items="estanques"
                                    item-text="nombre"
                                    item-value="id"
                                    color="blue darken-3"
                                    persistent-hint
                                    hide-details="auto"
                                    class="py-2"
                                ></v-select>
                            </td>
                            <td class="text-center">
                                <v-text-field
                                    v-for="(prod_ac, index) in item.produccion_aceite"
                                    :key="index"
                                    v-model="item.produccion_aceite[index]"
                                    type="number" 
                                    outlined 
                                    dense
                                    hide-details="auto"
                                    class="py-2"
                                ></v-text-field>
                            </td>
                            <td class="text-center">
                                <v-text-field
                                    label="Folio de producción"
                                    v-model="item.folio_produccion"
                                ></v-text-field>
                            </td>
                            <td class="text-center">
                                <v-icon v-if="item.produccion_aceite.length <= estanques.length" @click="agregarFila(item)" dark color="green darken 1">add_circle</v-icon>
                                <v-icon v-if="item.produccion_aceite.length > 1" @click="eliminarFila(item)" dark color="red darken 1">remove_circle</v-icon>
                            </td>
                        </tr>

                        <!-- jumbos que aun no han sido asignados (solo tienen PA) -->
                        <tr v-for="(item) in jumbos_sin_asignar" :key="item.id" style="background-color:#FFECB3;">
                            <td class="text-center">{{item.id?item.linea.nombre_linea:item.linea}}</td>
                            <td class="text-center">{{item.id?item.tipo_mp.tipo_materia_prima:item.materia_prima}}</td>
                            <td class="text-center"><v-btn @click="verJumbos(item)" icon><v-icon>visibility</v-icon></v-btn>({{item.cantidad_jumbos_sistema}})</td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <!-- <td class="text-center"><v-text-field v-model="item.cantidad_jumbos" type="number" outlined dense></v-text-field></td> -->
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                        </tr>
                        <!-- jumbos que aun no han sido asignados (solo tienen PA) -->

                        <!-- jumbos que aun no han sido asignados (solo tienen PA) -->
                        <tr v-for="(item) in jumbos_reprocesados" :key="item.id" style="background-color:#CCC;">
                            <td class="text-center">{{item.id?item.linea.nombre_linea:item.linea}}</td>
                            <td class="text-center">{{item.id?item.tipo_mp.tipo_materia_prima:item.materia_prima}}</td>
                            <td class="text-center"><v-btn @click="verJumbos(item)" icon><v-icon>visibility</v-icon></v-btn>({{item.cantidad_jumbos_sistema}})</td>
                            <td class="text-center">{{item.total_kilos_sistema}}</td>
                            <td class="text-center">{{item.produccion}}</td>
                            <!-- <td class="text-center"><v-text-field v-model="item.cantidad_jumbos" type="number" outlined dense></v-text-field></td> -->
                            <td class="text-center">{{item.peso_aproximado_jumbo}}</td>
                            <td class="text-center"> </td>
                            <td class="text-center"> </td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                        </tr>
                        <!-- jumbos que aun no han sido asignados (solo tienen PA) -->

                        <!-- jumbos de barrido (solo informativo) -->
                        <tr v-for="(item) in jumbos_de_barrido" :key="item.id" style="background-color:#CCC;">
                            <td class="text-center">{{item.id?item.linea.nombre_linea:item.linea}}</td>
                            <td class="text-center">{{item.id?item.tipo_mp.tipo_materia_prima:item.materia_prima}}</td>
                            <td class="text-center"><v-btn @click="verJumbos(item)" icon><v-icon>visibility</v-icon></v-btn>({{item.cantidad_jumbos_sistema}})</td>
                            <td class="text-center">{{item.total_kilos_sistema}}</td>
                            <td class="text-center">{{item.produccion}}</td>
                            <!-- <td class="text-center"><v-text-field v-model="item.cantidad_jumbos" type="number" outlined dense></v-text-field></td> -->
                            <td class="text-center">{{item.peso_aproximado_jumbo}}</td>
                            <td class="text-center"> </td>
                            <td class="text-center"> </td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                        </tr>
                        <!-- jumbos de barrido (solo informativo) -->

                        <tr>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                            <td class="text-center"><h3><strong>{{totales.total_jumbos_sistema}}</strong></h3></td>
                            <td class="text-center"><h3><strong>{{totales.total_kilos_sistema | formatear_miles}}</strong></h3></td>
                            <td class="text-center"><h3><strong>{{totales.total_kilos_produccion | formatear_miles}}</strong></h3></td>
                            <td class="text-center"></td>
                            <td class="text-center"><h3><strong>{{totales.total_kilos_mmpp | formatear_miles}}</strong></h3></td>
                            <td class="text-center"><h3><strong>{{totales.total_kilos_produccion | formatear_miles}}</strong></h3></td>
                            <td class="text-center"></td>
                            <td class="text-center"><h3><strong>{{totales.total_produccion_aceite | formatear_miles}}</strong></h3></td>
                            <td class="text-center"></td>
                            <td class="text-center"></td>
                        </tr>

                    </tbody>
                </v-simple-table>
            </v-card>
        </v-col>

        <v-divider></v-divider>
        <!-- detalle recepciones -->
        <!-- <v-col cols="12">
            <v-card>
                <v-simple-table height="700px" dense fixed-header>
                    <template v-slot:default>
                        
                    <thead>
                        <tr>
                            <th class="text-center">#</th>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Ticket</th>
                            <th class="text-center">MateriaPrima</th>
                            <th class="text-center">Guía</th>
                            <th class="text-center">Kilos</th>
                            <th class="text-center">Cambiar Linea</th>
                            <th class="text-center">Sel.</th>
                            <th class="text-center">Cambiar proceso</th>
                            <th class="text-center">L1</th>
                            <th class="text-center">L2</th>
                            <th class="text-center">PorDistribuir</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in recepciones" :key="index">
                            <td>{{ index }}</td>
                            <td>{{ item.fecha }}</td>
                            <td v-bind:class="{restriccion: item.restriccion}">{{ item.ticket }}</td>
                            <td v-bind:class="{restriccion: item.restriccion}">{{ item.materia_prima }}</td>
                            <td v-bind:class="{restriccion: item.restriccion}">
                                <span class="float-right" >{{ item.guia }}</span>
                            </td>
                            <td><span class="float-right" >{{ item.peso | formatear_miles }} </span></td>
                            <td>
                                <span v-if="trazabilidad_bloqueada">{{ detalle_lineas.find(det => det.id === item.linea_proceso).nombre }} <v-icon title="Trazabilidad se encuentra bloqueda, no es posible cambiar de línea" color="blue">info</v-icon> </span>
                                <v-select
                                    v-else
                                    :items="item.restriccion ? detalle_lineas_filtradas[0] : detalle_lineas_filtradas[1]"
                                    v-model="item.linea_proceso"
                                    item-text="nombre"
                                    item-value="id"
                                    color="blue darken-3"
                                    hide-details
                                    dense
                                    style="max-width:120px;"
                                    @change="saveSeleccionado(item, index)"
                                >
                                </v-select>
                            </td>
                            <td>
                                <input type="checkbox" @change="saveSeleccionado(item, index)" v-model="item.seleccionada" :checked="item.seleccionada > 0" style="transform: scale(1.5)" />
                                {{ item.parcial | formatear_miles}}
                            </td>
                            <td>
                                <span v-if="trazabilidad_bloqueada">{{ item.linea_proceso === 1 ? 'Sin restricción' : 'Con restricción' }} <v-icon title="Trazabilidad se encuentra bloqueda, no es posible cambiar de proceso" color="blue">info</v-icon> </span>
                                <v-select
                                    v-else
                                    :items="item.linea_proceso === 1 ? procesos[0] : procesos[1]"
                                    v-model="item.proceso"
                                    item-text="nombre"
                                    item-value="id"
                                    color="blue darken-3"
                                    hide-details
                                    dense
                                    style="max-width:120px;"
                                    @change="saveSeleccionado(item, index)"
                                >
                                </v-select>
                            </td>
                            <td>
                                <ul v-if="(item.distrib_patio_texto != '')">
                                    <p v-for="it in item.distrib_patio" :key="it.id" v-if="it.linea == 1">
                                        <span>{{ it.pozo }}={{ it.kilos | formatear_miles }}</span>
                                    </p>
                                </ul>
                            </td>
                            
                            <td>
                                <ul v-if="(item.distrib_patio_texto != '')">
                                    <p v-for="it in item.distrib_patio" :key="it.id" v-if="it.linea == 2" >
                                        <span>{{ it.pozo }}={{ it.kilos | formatear_miles }}</span>
                                    </p>
                                </ul>
                            </td>
                            <td>
                                <span class="float-right" >
                                    {{ item.distribuir | formatear_miles }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-col> -->
        <!-- <pre>{{lista}}</pre> -->

        <!-- <v-col>
            <v-card>
                <v-row>
                    <v-col cols="4"></v-col>
                    <v-col cols="2">
                        {{ primero }} - {{ ultimo }}
                    </v-col>
                    <v-col cols="3">
                        <v-btn color="success" title="Seleccionar automáticamente las filas intermedias entre las seleccionadas" @click="seleccionarFilas">SELECCIONAR FILAS</v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-col> -->


        <v-dialog
            v-model="abrir_modal"
            width="500"
        >

            <v-card>
                <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                    >
                    Detalle de Maxisacos sistema
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col >
                            {{`${produccion.pe_as}`}}
                        </v-col>

                        <!-- <v-col v-for="jumbo in produccion.pe_as" :key="jumbo.resultado_id">
                            {{`${produccion.control_planta_prefijo}${produccion.pe_as}`}}
                        </v-col> -->
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="abrir_modal = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="abrir_modal2"
            width="500"
        >

            <v-card>
                <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                    >
                    Detalle de Maxisacos Consolidados
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col >
                            {{`${produccion.jumbos}`}}
                        </v-col>

                        <!-- <v-col v-for="jumbo in produccion.pe_as" :key="jumbo.resultado_id">
                            {{`${produccion.control_planta_prefijo}${produccion.pe_as}`}}
                        </v-col> -->
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="abrir_modal2 = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    <!-- detalle jumbos -->
    </v-dialog>
  </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import Data_Table from '@/components/shared/Data_Table.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
// import axios from 'axios'
export default {
    data:()=>({
        primero:null,
        ultimo:null,
        mostrar:false,
        turno: [],
        lista:[],
        jumbos_sin_asignar:[],
        jumbos_reprocesados:[],
        jumbos_de_barrido:[],
        recepciones:[],
        turnos: [],
        alert:false,
        fecha: new Date().toISOString().substr(0, 10),
        mostrar_fecha: false,
        abrir_modal:false,
        abrir_modal2:false,
        produccion:{},
        sumita:0,
        cont:0,
        timeout: true,
        //configuracion para datatable
        cabeceras:[
            {
                text: 'Linea',
                align: 'center',
                sortable: true,
                value: 'linea',
            },
            {
                text: 'Maxisacos',
                align: 'center',
                sortable: true,
                value: 'jumbos',
            },
            {
                text: 'Materia prima',
                align: 'center',
                sortable: true,
                value: 'materia_prima',
            },
            {
                text: 'Cantidad Maxisacos',
                align: 'center',
                sortable: true,
                value: 'cantidad_jumbos',
            },
            {
                text: 'Total Kilos',
                align: 'center',
                sortable: true,
                value: 'total_kg',
            }
        ],
        acciones:[],
        estanques: [],
        detalle_lineas: [],
    }),
    beforeDestroy() {
        Event.$off('abrir_modal_produccion_harina_dia');
    },
    mounted() {
        this.cargarEstanques();
        Event.$on('abrir_modal_produccion_harina_dia',(lineas, fecha)=>{
            this.mostrar = true;
            this.alert = false;
            this.detalle_lineas = lineas;
            this.fecha = fecha;
            this.timeout = true;
            this.cargarDatos();
        });
    },
    methods: {
       /* async cargarTurnos(){
            let url = `${this.base_url}turnos`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.turnos = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },*/
        async cargarEstanques(){
            const url = `${this.base_url}estanque_aceites`;
            await this.axios.get(url,this.headers).then(res => {
                this.estanques = res.data.data;
            }).catch(error => {
                console.log('error',error);
            });
        },
        agregarFila(item) {
            item.estanques.push(this.estanques[0].id);
            item.produccion_aceite.push(0);
        },
        eliminarFila(item) {
            item.estanques.pop();
            item.produccion_aceite.pop();
        },
        async cargarDatos(){
            this.lista = [];
            if(this.timeout) {
                setTimeout(() => {
                    this.mostrarLoading({titulo: 'Cargando Datos...', color: 'green'});
                }, 1);
            } else {
                this.mostrarLoading({titulo: 'Cargando Datos...', color: 'green'});
            }
            let url = `${this.base_url}produccion_turno/fecha/${this.fecha}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.trazabilidad_bloqueada = response.data.trazabilidad_bloqueada;
                this.lista = response.data.items_con_jumbos;
                this.jumbos_sin_asignar = response.data.items_sin_jumbos;
                this.jumbos_reprocesados = response.data.jumbos_reprocesados;
                this.jumbos_de_barrido = response.data.jumbos_de_barrido;
                this.lista.forEach((item,idx) => {
                    if(this.lista[idx].estanques.length === 0) 
                        this.$set(this.lista[idx], 'estanques', [ this.estanques[0].id ]);
                    if(this.lista[idx].produccion_aceite.length === 0)
                        this.$set(this.lista[idx], 'produccion_aceite', [ 0 ]);
                    
                    let peso = item.produccion / item.cantidad_jumbos_sistema;
                    this.$set(this.lista[idx],'peso_aproximado_jumbo',Math.round(peso));
                });
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading()
                this.cargarRecepciones()
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar datos ");
            });
        },

        calcularPesoJumbo(idx,item){
            let peso = item.produccion / item.cantidad_jumbos_sistema;
            this.$set(this.lista[idx],'peso_aproximado_jumbo',Math.round(peso))
            //cantidad_jumbos_sistema,
        },
        calcularRendimiento(idx,item){
            let rendim = item.produccion / item.mp_procesada * 100;
            this.$set(this.lista[idx],'rendimiento',rendim.toFixed(1))
            //cantidad_jumbos_sistema,
        },
        async guardarProduccion(){
            // let body = `{"data":[`;
            let b = {data:[]};
            // let coma = ""; 
            this.mostrarLoading({titulo:'Guardando Producción...',color:'green'})

            this.lista.forEach((pro,index) => {
                console.log(pro.jumbos_id);
                b.data.push({
                    id:pro.id,
                    fecha:this.fecha,
                    turnos_id:this.turno.id,
                    tipo_mps_id:pro.tipo_mps_id,
                    cantidad_jumbos:pro.cantidad_jumbos,
                    cantidad_jumbos_sistema:pro.cantidad_jumbos_sistema,
                    produccion:pro.produccion,
                    mp_procesada:pro.mp_procesada,
                    tipo_produccion_id:1,
                    peso_aproximado_jumbo:pro.peso_aproximado_jumbo,
                    jumbos:pro.jumbos,
                    jumbos_id:pro.jumbos_id,
                    lineas_id:pro.lineas_id,
                    estanques: pro.estanques,
                    produccion_aceite: pro.produccion_aceite, 
                    folio_produccion: pro.folio_produccion
                });
            });
            
            let url = `${this.base_url}produccion_turno/guardar`;
            await this.axios.post(url,b,this.headers).then((res)=>{
                this.ocultarLoading();
                console.log('realizado',res.data);
                this.alert=true;
                this.cargarDatos();
            }).catch((error)=>{
                this.alert=false;
                this.errorMessage(error, "Error al grabar producción ");
            });
        },

        verJumbos(item){
            console.log(item);
            this.produccion = item;
            this.abrir_modal = true;
        },

        verJumbos2(item){
            console.log(item);
            this.produccion = item;
            this.abrir_modal2 = true;
        },

        async cargarRecepciones(){
            return;
            this.mostrarLoading({titulo:'Cargando Recepción Materia Prima...',color:'green'})

            let url = `${this.base_url}mp_procesada/recepciones/${this.fecha}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('recepciones:',res.data);
                this.recepciones = res.data;
                this.total_mmpps();
                this.ocultarLoading();
                this.timeout = false;
            }).catch((e)=>{
                this.ocultarLoading();
                this.errorMessage(e, "Error al cargar recepciones ");
            });
        },
        async seleccionarFilas(){
            if ((this.primero || this.primero === 0) && (this.ultimo || this.ultimo === 0)) {
                this.cont = 1;
                this.mostrarLoading({titulo:'Registrando Seleccionados ...'+this.cont, color:'green'})
                if (parseInt(this.primero) > parseInt(this.ultimo)) {
                    let temp_last = parseInt(this.primero)
                    this.primero = parseInt(this.ultimo)
                    this.ultimo = temp_last
                }
                this.recepciones.forEach((r, idx) => {
                    if ((idx > this.primero) && (idx < this.ultimo) && (r.seleccionada == 0)) {
                        this.$set(this.recepciones[idx],'seleccionada',1)
                        this.saveSeleccionado(r, null)
                        this.cont += 1
                        console.log(" seleccionada " + this.cont)
                    }
                });
                this.ocultarLoading();
            } else {
                console.log("no se encontró primera o ultima fila seleccionada. primera:" + this.primero + " ultima:" + this.ultimo )
            }
        },
        async saveSeleccionado(item, index){
            if(this.trazabilidad_bloqueada) {
                this.mostrarLoading({ titulo: 'La trazabilidad se encuentra bloqueda, no se puede guardar', color: 'red'})
                return;
            }

            item.seleccionada = item.seleccionada ? 1 : 0; 
            /* ((item.seleccionada == true) || (item.seleccionada == 1)) ? item.seleccionada = 1 : item.seleccionada = 0; */
            if ((item.seleccionada === 1) || (item.seleccionada === 0)){
                let url = `${this.base_url}mp_procesada/registrar_guia`;
                let data = {    fecha: this.fecha,
                                data: {
                                    'guias_id': item.guias_id,
                                    'total': item.total,
                                    'parcial': item.parcial,
                                    'seleccionada': item.seleccionada,
                                    'guia': item.guia,
                                    'mps_id': item.mps_id,
                                    'lineas_id': item.linea_proceso,
                                    'proceso': item.proceso,
                                    'restriccion': item.restriccion,
                                },
                            }
                await this.axios.post(url, data, this.headers).then((res)=>{
                    if (index != null){
                        if (this.primero == null) {
                            this.primero = index
                        }else {
                            if (this.ultimo == null) {
                                this.ultimo = index
                            } else {
                                this.primero = parseInt(this.ultimo)
                                this.ultimo = index
                            }
                        }
                    }
                    console.log(" index " + index)
                    this.alert = true;
                    this.total_mmpps();
                    // TODO: AQUI CALCULAR LA MMPP DE LA GUIA SELECCIONADA
                }).catch((error)=>{
                    console.log(error);
                    this.errorMessage(error, "Error al agregar recepción ");
                });
            }
        },
        /**
         * Actualiza label debajo de input en columna "Materia Prima Producción" (en base a recepciones seleccionadas)
         */
        total_mmpps(){
            this.lista.forEach((fila,idx) => {
                this.sumita = 0
                this.recepciones.forEach((r, id) => {
                    if ((r.seleccionada == 1) && (r.linea_proceso == fila.lineas_id)){
                        if(fila.tipo_mps_id == 1){
                            if((r.mps_id == fila.tipo_mps_id) && (r.proceso == 1)){
                                this.sumita += parseInt(r.parcial)
                            }
                        } else {
                            if((r.mps_id == fila.tipo_mps_id) || ((r.mps_id == 1) && (fila.tipo_mps_id == 12) && (r.proceso == 2))){
                                this.sumita += parseInt(r.parcial)
                            }
                        }
                    }
                    /* console.log("mmpp",id," mps_id",r.mps_id,">",fila.tipo_mps_id,"p>",r.proceso,
                    " linea",r.linea_proceso,">",fila.lineas_id, " valor>", r.parcial) */
                });
                this.$set(this.lista[idx],'mp_procesada_label',this.sumita)
            });
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers']),

        detalle_lineas_filtradas() {
            const opciones_con = this.lista.filter(val => val.tipo_mps_id === 12).map(val => val.lineas_id);
            const opciones_sin = this.lista.filter(val => val.tipo_mps_id === 1).map(val => val.lineas_id);
            return [
                this.detalle_lineas.filter(det => opciones_con.includes(det.id)),
                this.detalle_lineas.filter(det => opciones_sin.includes(det.id)),
            ];
        },

        procesos() {
            const procesos = [{ id: 1, nombre: 'Sin restricción'}, { id: 2, nombre: 'Con restricción'}];
            const opciones_l1 = this.lista.filter(val => val.lineas_id === 1).map(val => val.tipo_mps_id);
            const opciones_l2 = this.lista.filter(val => val.lineas_id === 2).map(val => val.tipo_mps_id);
            return [
                procesos.filter(proceso => {
                    proceso.mps_id = proceso.id === 1 ? 1 : 12;
                    return opciones_l1.includes(proceso.mps_id);
                }),
                procesos.filter(proceso => {
                    proceso.mps_id = proceso.id === 1 ? 1 : 12;
                    return opciones_l2.includes(proceso.mps_id);
                }),
            ];
        },

        totales(){
            return {
                total_jumbos_sistema: this.lista.reduce((a, b) => a + b.cantidad_jumbos_sistema, 0),
                total_jumbos_prod: this.lista.reduce((a, b) => a + b.cantidad_jumbos, 0),
                total_kilos_sistema: this.lista.reduce((a, b) => a + Number(b.total_kilos_sistema), 0),
                total_kilos_produccion: this.lista.reduce((a, b) => a + Number(b.produccion), 0),
                total_kilos_mmpp: this.lista.reduce((a, b) => a + Number(b.mp_procesada), 0),
                total_produccion_aceite: this.lista.reduce((a, b) => a + Number(b.produccion_aceite.reduce((a, b) => a + Number(b))), 0),
            }
        },
        
        fecha_formateada () {
          return this.fecha ? this.moment(this.fecha).format('DD-MM-YYYY') : '';
        }
    },
    components:{
        //'modal':Modal,
        'data-table':Data_Table,
        DatePicker
    }
}
</script>
<style>
    .mx-datepicker{
        width: 100% !important;
    }

    input[type=number]{
        text-align: right;
    }
    th {color: white !important; font-size: 0.9em !important; }
    td {border-right:0.5px #00897B solid;}
    .restriccion{ background-color: #f4b1b1 !important; }

    /**quitar las flechitas Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    table tr th, thead tr th{
        border-right: thin solid rgba(0, 0, 0, 0.12);
        background-color: #243674 !important;
        color: #fff;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>